import React from "react";
import Field from "@gqlapp/forms-client-react/FieldAdapter";
import Radios from "@gqlapp/base/RenderRadiosBox";
import Checkboxes from "@gqlapp/base/RenderCheckboxes";
import ControlRender from "./Control";
import Style from './Style';
export default Style(function Image(props){
	let { sx, id: name, values, options, setFieldValue, style, required } = props || {};
	options = options || [];
	values = values || {}
	required = !!required;

	let value = values[name];

	options = options.map(({ title: label, value, url, price })=>{
		label = (<div className={'title'}>{label}</div>);
		if(price){
			label = (<>{label}<div className={'price'}>{price}</div></>);
		}
		return ({ label, value, url })
	});

	let RenderField = Radios;
	if(!!style){ RenderField = Checkboxes }

	const Control = ControlRender({ options, style })
	return <>
		<Field
			sx={sx}
			{...{ label: props?.name, component: RenderField }}
			{...{ value, name, options, required, onChange: setFieldValue }}
			{...{ control: <Control /> }}
		/>
	</>
})